export default "__VITE_ASSET__BNnBzMmh__"